module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.createOrg) ? _c('v-container', {
    staticClass: "organization",
    attrs: {
      "fluid": ""
    }
  }, [_c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbar,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbar = $event
      }
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "flex",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('p', {
    staticClass: "font title"
  }, [_vm._v("Introduce el código de la organización")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "font input-text",
    attrs: {
      "prepend-inner-icon": "domain",
      "name": "name",
      "append-outer-icon": "send",
      "label": "Código de la organización",
      "type": "name"
    },
    on: {
      "click:append-outer": _vm.joinOrganization
    },
    model: {
      value: (_vm.organizationCode),
      callback: function($$v) {
        _vm.organizationCode = $$v
      },
      expression: "organizationCode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "div-create-org"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require('../../assets/icons/add-organization.png')
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "font create-org-button",
    on: {
      "click": _vm.newOrganizationButton
    }
  }, [_vm._v("Crear organización")])])], 1)], 1) : _c('v-container', {
    staticClass: "organization",
    attrs: {
      "fluid": ""
    }
  }, [_c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbar,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbar = $event
      }
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "flex",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('p', {
    staticClass: "font title"
  }, [_c('b', [_vm._v("Nombra a la organización")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "font input-text",
    attrs: {
      "prepend-inner-icon": "domain",
      "name": "name",
      "label": "Nombre de la organización",
      "type": "name"
    },
    model: {
      value: (_vm.organizationName),
      callback: function($$v) {
        _vm.organizationName = $$v
      },
      expression: "organizationName"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "div-continue-btn"
  }, [_c('v-btn', {
    class: this.organizationName.length ? 'continue-btn' : 'continue-btn grey--text',
    attrs: {
      "block": "",
      "color": this.organizationName.length ? 'info' : '#DFDFDF'
    },
    on: {
      "click": _vm.createOrganizationButton
    }
  }, [_vm._v("Crear organización")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-517acd76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/NewOrganization.vue
// module id = 772
// module chunks = 9